import React, { createContext, ReactNode, useContext, useState } from 'react';
import { InboxItemType, SeenStatus } from '../gql/types'; // adjust import path

export interface InboxOptimisticUpdate {
    updateID: string;
    itemType: InboxItemType;
    seenStatus: SeenStatus;
}

interface InboxUpdatesContextValue {
    optimisticUpdates: InboxOptimisticUpdate[];
    addOptimisticUpdate: (update: InboxOptimisticUpdate) => void;
}

const InboxUpdatesContext = createContext<InboxUpdatesContextValue | undefined>(undefined);

interface InboxUpdatesProviderProps {
    children: ReactNode;
}

export const InboxUpdatesProvider: React.FC<InboxUpdatesProviderProps> = ({ children }) => {
    const [optimisticUpdates, setOptimisticUpdates] = useState<InboxOptimisticUpdate[]>([]);

    const addOptimisticUpdate = (update: InboxOptimisticUpdate) => {
        setOptimisticUpdates(prev => [...prev, update]);
    };

    return (
        <InboxUpdatesContext.Provider value={{ optimisticUpdates, addOptimisticUpdate }}>
            {children}
        </InboxUpdatesContext.Provider>
    );
};

export const useInboxUpdates = () => {
    const context = useContext(InboxUpdatesContext);
    if (!context) {
        throw new Error("useInboxUpdates must be used within an InboxUpdatesProvider");
    }
    return context;
};
